import {inject, Injectable} from '@angular/core';
import {SwUpdate} from "@angular/service-worker";
import {PlatformService} from "./platform.service";
import {MessageService} from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  private readonly platformService = inject(PlatformService);
  private readonly swUpdate = inject(SwUpdate);
  private readonly messageService = inject(MessageService);

  private isPwaInstalled = false;

  constructor() {
    this.detectPwaInstallation();

    this.swUpdate.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_DETECTED') {
        this.messageService.add(
          {
            severity: 'info',
            summary: 'Update available',
            detail: 'New version available. Reloading...',
            sticky: true,
            closable: true,
            life: undefined,
          }
        )
      }
    });
  }

  // Detect if the app is running as a PWA
  private detectPwaInstallation(): void {
    if (this.platformService.isServer) {
      return;
    }
    this.isPwaInstalled = window.matchMedia('(display-mode: standalone)').matches;

    // Also check for beforeinstallprompt (not installed) and appinstalled (installed)
    window.addEventListener('appinstalled', () => {
      console.log('PWA installed');
      this.isPwaInstalled = true;
    });
  }


  // Check for updates manually
  public async checkForUpdates() {
    try {
      if (this.swUpdate.isEnabled && navigator.serviceWorker.controller) {
        console.log('Checking for updates...');
        const update = await Promise.race([
          this.swUpdate.checkForUpdate(),
          new Promise<boolean>((resolve) =>
            setTimeout(() => resolve(false), 4000))
        ]);

        console.log('Checked for updates:', update);

        if (update) {
          await this.swUpdate.activateUpdate();
          window.location.reload();
        }
      }
    } catch (error) {
      console.error('Error checking for updates:', error);
    }
  }

  promptInstallDialog() {
    const pwaInstall: any = document.getElementsByTagName('pwa-install')[0];
    pwaInstall.showDialog();
  }
}
